import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { ACTION_NODE_LINK, ACTION_NODES, ACTION_TYPE_PRIMARY, ACTION_TYPES } from 'constants/Action';

import { IconElem, Link as LinkElem } from './Cta.styles';
import validateHref from './Cta.validation';

const CtaLink = (props) => {
  const { children, showIcon, styleType, external, href, as, ...rest } = props;
  return external ? (
    <LinkElem href={href} showIcon={showIcon} styleType={styleType} data-test-id={`button-${styleType}`} {...rest}>
      {children}
      {showIcon && <IconElem icon="arrow-right" />}
    </LinkElem>
  ) : (
    <Link href={href} as={as} passHref>
      <LinkElem showIcon={showIcon} styleType={styleType} data-test-id={`button-${styleType}`} {...rest}>
        {children}
        {showIcon && <IconElem icon="arrow-right" />}
      </LinkElem>
    </Link>
  );
};

CtaLink.propTypes = {
  children: PropTypes.node.isRequired,
  showIcon: PropTypes.bool,
  node: PropTypes.oneOf(ACTION_NODES),
  styleType: PropTypes.oneOf(ACTION_TYPES),
  href: validateHref,
  external: PropTypes.bool,
  as: PropTypes.string,
};

CtaLink.defaultProps = {
  showIcon: true,
  node: ACTION_NODE_LINK,
  styleType: ACTION_TYPE_PRIMARY,
  href: '',
  external: false,
  as: '',
};

export default CtaLink;
